import { LightMode, useColorMode, Flex } from '@chakra-ui/react';
import { PropsWithChildren, useEffect } from 'react';

export const NonAuthLayout = ({ children }: PropsWithChildren) => {
  const { setColorMode } = useColorMode();

  document.body.setAttribute('data-layout-mode', 'light');
  document.body.removeAttribute('data-sidebar');

  useEffect(() => {
    setColorMode('light');

    return () => {
      setColorMode('light');
    };
  });

  return (
    <LightMode>
      <Flex h='100vh' w='full' top={0} left={0} backgroundColor='chakra-body-bg'>
        <Flex overflow='auto' direction='column' flexGrow={1}>
          {children}
        </Flex>
      </Flex>
    </LightMode>
  );
};
